import Link from "next/link";
import TelegramListingChannelsFollow from "@/components/telegram/TelegramListingChannelsFollow";
import type { FaqAnswer, FaqBlock, FaqTextPart } from "@/lib/faq";

function renderParts(parts: FaqTextPart[], keyPrefix: string) {
  return parts.map((part, index) => {
    const key = `${keyPrefix}-${index}`;
    if (typeof part === "string") {
      return <span key={key}>{part}</span>;
    }
    if (part.kind === "bold") {
      return (
        <span key={key} className="font-bold">
          {part.text}
        </span>
      );
    }
    return (
      <Link key={key} href={part.href} className="text-blue-500">
        {part.label}
      </Link>
    );
  });
}

function FaqBlockView({ block, index }: { block: FaqBlock; index: number }) {
  if (block.type === "paragraph") {
    return (
      <p className={index > 0 ? "mt-3" : undefined}>
        {renderParts(block.parts, `p-${index}`)}
      </p>
    );
  }
  if (block.type === "orderedList") {
    return (
      <ol className="mt-2 list-inside list-decimal">
        {block.items.map((item, i) => (
          <li key={`ol-${index}-${i}`}>
            {renderParts(item, `ol-${index}-${i}`)}
          </li>
        ))}
      </ol>
    );
  }
  if (block.type === "unorderedList") {
    return (
      <ul className="mt-2 list-inside list-disc">
        {block.items.map((item, i) => (
          <li key={`ul-${index}-${i}`}>
            {renderParts(item, `ul-${index}-${i}`)}
          </li>
        ))}
      </ul>
    );
  }
  if (block.name === "telegram-listing-channels") {
    return (
      <div className="mt-3">
        <TelegramListingChannelsFollow showHeading={false} description="" />
      </div>
    );
  }
  return null;
}

type FaqAnswerProps = {
  answer: FaqAnswer;
};

export default function FaqAnswerView({ answer }: FaqAnswerProps) {
  if (typeof answer === "string") {
    return <>{answer}</>;
  }
  return (
    <>
      {answer.map((block, index) => (
        <FaqBlockView key={index} block={block} index={index} />
      ))}
    </>
  );
}
